import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.object.from-entries.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
// ../../../react-shim.js
import React from "react";

// src/media-query.tsx
import { useTheme } from "@chakra-ui/system";
var getBreakpoint = function getBreakpoint(theme, value) {
  var _ref;
  var _a;
  return (_ref = (_a = theme == null ? void 0 : theme.breakpoints) == null ? void 0 : _a[value]) !== null && _ref !== void 0 ? _ref : value;
};
function useQuery(props) {
  var _props$breakpoint = props.breakpoint,
    breakpoint = _props$breakpoint === void 0 ? "" : _props$breakpoint,
    below = props.below,
    above = props.above;
  var theme = useTheme();
  var bpBelow = getBreakpoint(theme, below);
  var bpAbove = getBreakpoint(theme, above);
  var query = breakpoint;
  if (bpBelow) {
    query = "(max-width: ".concat(bpBelow, ")");
  } else if (bpAbove) {
    query = "(min-width: ".concat(bpAbove, ")");
  }
  return query;
}

// src/use-media-query.ts
import { useEnvironment } from "@chakra-ui/react-env";
import { useEffect, useState } from "react";
function useMediaQuery(query) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$ssr = options.ssr,
    ssr = _options$ssr === void 0 ? true : _options$ssr,
    fallback = options.fallback;
  var env = useEnvironment();
  var queries = Array.isArray(query) ? query : [query];
  var fallbackValues = Array.isArray(fallback) ? fallback : [fallback];
  fallbackValues = fallbackValues.filter(function (v) {
    return v != null;
  });
  var _useState = useState(function () {
      return queries.map(function (query2, index) {
        return {
          media: query2,
          matches: ssr ? !!fallbackValues[index] : env.window.matchMedia(query2).matches
        };
      });
    }),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  useEffect(function () {
    setValue(queries.map(function (query2) {
      return {
        media: query2,
        matches: env.window.matchMedia(query2).matches
      };
    }));
    var mql = queries.map(function (query2) {
      return env.window.matchMedia(query2);
    });
    var handler = function handler(evt) {
      setValue(function (prev) {
        return prev.slice().map(function (item) {
          if (item.media === evt.media) return _objectSpread(_objectSpread({}, item), {}, {
            matches: evt.matches
          });
          return item;
        });
      });
    };
    mql.forEach(function (mql2) {
      if (typeof mql2.addListener === "function") {
        mql2.addListener(handler);
      } else {
        mql2.addEventListener("change", handler);
      }
    });
    return function () {
      mql.forEach(function (mql2) {
        if (typeof mql2.removeListener === "function") {
          mql2.removeListener(handler);
        } else {
          mql2.removeEventListener("change", handler);
        }
      });
    };
  }, [env.window]);
  return value.map(function (item) {
    return item.matches;
  });
}

// src/media-query.hook.ts
function usePrefersReducedMotion(options) {
  var _useMediaQuery = useMediaQuery("(prefers-reduced-motion: reduce)", options),
    _useMediaQuery2 = _slicedToArray(_useMediaQuery, 1),
    prefersReducedMotion = _useMediaQuery2[0];
  return prefersReducedMotion;
}
function useColorModePreference(options) {
  var _useMediaQuery3 = useMediaQuery(["(prefers-color-scheme: light)", "(prefers-color-scheme: dark)"], options),
    _useMediaQuery4 = _slicedToArray(_useMediaQuery3, 2),
    isLight = _useMediaQuery4[0],
    isDark = _useMediaQuery4[1];
  if (isLight) return "light";
  if (isDark) return "dark";
  return void 0;
}

// src/use-breakpoint.ts
import { useTheme as useTheme2 } from "@chakra-ui/system";

// ../../utilities/shared-utils/src/index.ts
function isObject(value) {
  var type = typeof value;
  return value != null && (type === "object" || type === "function") && !Array.isArray(value);
}

// src/use-breakpoint.ts
function useBreakpoint(arg) {
  var _ref3;
  var _a;
  var opts = isObject(arg) ? arg : {
    fallback: arg !== null && arg !== void 0 ? arg : "base"
  };
  var theme = useTheme2();
  var breakpoints = theme.__breakpoints.details.map(function (_ref2) {
    var minMaxQuery = _ref2.minMaxQuery,
      breakpoint = _ref2.breakpoint;
    return {
      breakpoint: breakpoint,
      query: minMaxQuery.replace("@media screen and ", "")
    };
  });
  var fallback = breakpoints.map(function (bp) {
    return bp.breakpoint === opts.fallback;
  });
  var values = useMediaQuery(breakpoints.map(function (bp) {
    return bp.query;
  }), {
    fallback: fallback,
    ssr: opts.ssr
  });
  var index = values.findIndex(function (value) {
    return value == true;
  });
  return (_ref3 = (_a = breakpoints[index]) == null ? void 0 : _a.breakpoint) !== null && _ref3 !== void 0 ? _ref3 : opts.fallback;
}

// src/use-breakpoint-value.ts
import { useTheme as useTheme3 } from "@chakra-ui/system";
import { arrayToObjectNotation } from "@chakra-ui/breakpoint-utils";

// src/media-query.utils.ts
import { breakpoints as defaultBreakPoints } from "@chakra-ui/breakpoint-utils";
function getClosestValue(values, breakpoint) {
  var breakpoints = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultBreakPoints;
  var index = Object.keys(values).indexOf(breakpoint);
  if (index !== -1) {
    return values[breakpoint];
  }
  var stopIndex = breakpoints.indexOf(breakpoint);
  while (stopIndex >= 0) {
    var key = breakpoints[stopIndex];
    if (values.hasOwnProperty(key)) {
      index = stopIndex;
      break;
    }
    stopIndex -= 1;
  }
  if (index !== -1) {
    var _key = breakpoints[index];
    return values[_key];
  }
  return void 0;
}

// src/use-breakpoint-value.ts
function useBreakpointValue(values, arg) {
  var _a;
  var opts = isObject(arg) ? arg : {
    fallback: arg !== null && arg !== void 0 ? arg : "base"
  };
  var breakpoint = useBreakpoint(opts);
  var theme = useTheme3();
  if (!breakpoint) return;
  var breakpoints = Array.from(((_a = theme.__breakpoints) == null ? void 0 : _a.keys) || []);
  var obj = Array.isArray(values) ? Object.fromEntries(Object.entries(arrayToObjectNotation(values, breakpoints)).map(function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
      key = _ref5[0],
      value = _ref5[1];
    return [key, value];
  })) : values;
  return getClosestValue(obj, breakpoint, breakpoints);
}

// src/visibility.tsx
function Visibility(props) {
  var breakpoint = props.breakpoint,
    hide = props.hide,
    children = props.children,
    ssr = props.ssr;
  var _useMediaQuery5 = useMediaQuery(breakpoint, {
      ssr: ssr
    }),
    _useMediaQuery6 = _slicedToArray(_useMediaQuery5, 1),
    show = _useMediaQuery6[0];
  var isVisible = hide ? !show : show;
  var rendered = isVisible ? children : null;
  return rendered;
}

// src/show.tsx
function Show(props) {
  var children = props.children,
    ssr = props.ssr;
  var query = useQuery(props);
  return /* @__PURE__ */React.createElement(Visibility, {
    breakpoint: query,
    ssr: ssr
  }, children);
}
Show.displayName = "Show";

// src/hide.tsx
function Hide(props) {
  var children = props.children,
    ssr = props.ssr;
  var query = useQuery(props);
  return /* @__PURE__ */React.createElement(Visibility, {
    breakpoint: query,
    hide: true,
    ssr: ssr
  }, children);
}
Hide.displayName = "Hide";
export { Hide, Show, useBreakpoint, useBreakpointValue, useColorModePreference, useMediaQuery, usePrefersReducedMotion, useQuery };